import { VueModule } from '@Foundation/utilities';
import NewsletterSubscription from './code/Scripts/components/newsletter-subscription';

export default VueModule({
  components: {
    NewsletterSubscription
  }
});
